import axios from "axios";
import { API_HEADERS, SHIPMENTS_V2_BASE_URL } from "../../constants";
import { ICreateShipmentRequest } from "../../interfaces/ICreateShipmentRequest";

export const createShipmentRequest = async (requestPayload: ICreateShipmentRequest) => {
    try {
      const result = await axios.post(
        `${SHIPMENTS_V2_BASE_URL}/consignments/createShipment`,
        {
          ...requestPayload,
        },
        {
          headers: API_HEADERS,
        }
      );
  
      // TODO: Add type once response model is locked in by backend
      return result.data;
    } catch (error) {
      // Handle error appropriately (e.g., logging, error messages)
      console.error("Error creating shipment", error);
      throw error; // Re-throw the error to be handled by the caller
    }
  };